import React, {ReactElement} from 'react';
import {Divider} from '@customink/pigment-react';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import {useAppSelector} from '../../hooks';
import StoreBanner from '../../components/StoreBanner';
import StoreHeader from '../../components/StoreHeader';
import StoreFooter from '../../components/StoreFooter';
import StoreProductDetail from '../../components/StoreProductDetail';
import StoreProductDetailSidebar from '../../components/StoreProductDetailSidebar';
import ProductGrid from '../../components/ProductGrid';
import MobileProvider from '../../containers/MobileProvider';
import './index.scss';

export interface Props {
  storeSlug: string;
  productId: number;
}

const GRID_ORDER = {
  sidebar: {lg: 1, md: 1, sm: 3, xs: 3},
  divider: {lg: 2, md: 2, sm: 2, xs: 2},
  detailBody: {lg: 3, md: 3, sm: 1, xs: 1}
};

const ProductDetailLayout: React.FC<Props> = ({
  storeSlug,
  productId
}: Props): ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  return storeDetails ? (
    <div className="product-detail-layout">
      <MobileProvider>
        <StoreHeader storeSlug={storeSlug} preview={false} />
      </MobileProvider>

      <div className="product-detail-layout-body">
        <StoreBanner storeSlug={storeSlug} />
        <div className={`product-detail-container${mobile ? ' mobile' : ''}`}>
          <ProductGrid.Container spacing={1}>
            <ProductGrid.Item
              numColLg={4}
              numColMd={3}
              numColSm={1}
              gridKey="sidebar"
              order={GRID_ORDER.sidebar}>
              <StoreProductDetailSidebar storeSlug={storeSlug} />
            </ProductGrid.Item>
            <ProductGrid.Item
              numColLg={12}
              numColMd={12}
              numColSm={1}
              gridKey="divider"
              order={GRID_ORDER.divider}>
              <Divider
                orientation={mobile ? 'horizontal' : 'vertical'}
                className="divider"
              />
            </ProductGrid.Item>
            <ProductGrid.Item
              numColLg={1.5}
              numColMd={1.8}
              numColSm={1}
              order={GRID_ORDER.detailBody}>
              <StoreProductDetail storeSlug={storeSlug} productId={productId} />
            </ProductGrid.Item>
          </ProductGrid.Container>
        </div>
      </div>

      <StoreFooter storeSlug={storeSlug} preview={false} />
    </div>
  ) : null;
};

export default ProductDetailLayout;
